import { request } from '../../utils/request';
import type { ResponseGetLegacyAuthenticatedUser } from '../../app/ApiGen';

export type Response = ResponseGetLegacyAuthenticatedUser;

export const getLegacyAuthenticatedUser: () => Promise<Response> = async () =>
  request<Response>('/v2/apps/user', { method: 'GET' });
